import network from '@/services/network';
import {
  ApiResponse,
  CreateTeamRequest,
  PaginatedResponse,
  SearchParams,
  Team,
  TeamMemberInfo,
} from '@/types';
import { ErrorResponse } from '@/utils';

const getTeams = async (params: SearchParams = {}): Promise<PaginatedResponse<Team>> => {
  try {
    const { data } = await network.get<PaginatedResponse<Team>>('/teams', {
      params,
    });
    return data;
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

const getTeam = async (teamId: number): Promise<ApiResponse<Team>> => {
  try {
    const { data } = await network.get<ApiResponse<Team>>(`/teams/${teamId}`);
    return data;
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

const createTeam = async (teamData: CreateTeamRequest): Promise<ApiResponse<Team>> => {
  try {
    const { data } = await network.post<ApiResponse<Team>>(
      '/teams',
      teamData,
    );
    return data;
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

const updateTeam = async (teamId: number, teamData: Partial<Team>): Promise<ApiResponse<Team>> => {
  try {
    const { data } = await network.put<ApiResponse<Team>>(
      `/teams/${teamId}`,
      teamData,
    );
    return data;
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

const deleteTeam = async (teamId: number): Promise<void> => {
  try {
    await network.delete(`/teams/${teamId}`);
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

const getTeamMembers = async (teamId: number): Promise<{ data: TeamMemberInfo[] }> => {
  try {
    const { data } = await network.get<{ data: TeamMemberInfo[] }>(
      `/teams/${teamId}/members`,
    );
    return data;
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

const addTeamMember = async (teamId: number, userId: number): Promise<ApiResponse<TeamMemberInfo>> => {
  try {
    const { data } = await network.post<ApiResponse<TeamMemberInfo>>(
      `/teams/${teamId}/members`,
      { user_id: userId },
    );
    return data;
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

const removeTeamMember = async (teamId: number, userId: number): Promise<void> => {
  try {
    await network.delete(`/teams/${teamId}/members/${userId}`);
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

const teamApi = {
  getTeams,
  getTeam,
  createTeam,
  updateTeam,
  deleteTeam,
  getTeamMembers,
  addTeamMember,
  removeTeamMember,
};

export default teamApi;
